import { useState, useEffect, useCallback } from 'react'

const STORAGE_KEY = 'bio-theme'

function getSystemPreference() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function getInitialTheme() {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'light' || stored === 'dark') return stored
  return getSystemPreference()
}

export function useTheme() {
  const [theme, setThemeState] = useState(getInitialTheme)

  const applyTheme = useCallback((t) => {
    document.documentElement.setAttribute('data-theme', t)
  }, [])

  const setTheme = useCallback((t) => {
    setThemeState(t)
    localStorage.setItem(STORAGE_KEY, t)
    applyTheme(t)
  }, [applyTheme])

  const toggle = useCallback(() => {
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }, [theme, setTheme])

  // Apply on mount
  useEffect(() => {
    applyTheme(theme)
  }, [applyTheme, theme])

  // Follow system preference changes (unless user has explicitly chosen)
  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    function onChange(e) {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const next = e.matches ? 'dark' : 'light'
        setThemeState(next)
        applyTheme(next)
      }
    }
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [applyTheme])

  return { theme, toggle }
}
